import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ home, disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();

  const router = useRouter();
  // const { user } = useMockedUser();
  // const isUser = user?.userType === 'user';
  // const isOrganizer = user?.userType === 'organizer';
  // const isSuperAdmin = user?.userType === 'super-admin';

  const logo = (
    <Box
      component="img"
      src={theme.palette.mode === 'dark' ? "/logo/logoImage.png" : "/logo/logoLightMode.png"}
      sx={{ width: 55, height: 55, cursor: 'pointer', ...sx }}
    />
  );

  if (disabledLink) {
    return logo;
  }

  const handleClick = (e) => {
    e.preventDefault();
    router.replace("/");
    router.reload();
  };

  // const getHomePath = () => {
  //   if (home) return '/';
  //   if (isUser) return paths.dashboard.home;
  //   if (isOrganizer) return paths.adminDashboard.root;
  //   if (isSuperAdmin) return paths.superAdminDashboard.root;
  //   return '/'; // fallback
  // };

  return (
    // <Link component={RouterLink} href={getHomePath()} sx={{ display: 'contents' }}>
    <Link component={RouterLink} onClick={handleClick} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
